<template>
  <div>
      <section class="hero is-medium">

          <div class="hero-body">
              <div class="container has-text-centered">
                <p class="title">Biaggeo</p>
                <p class="subtitle">Biaggeo is an online platform for universities to foster entrepreneurship and innovation on their campus</p>
              </div>
          </div>

      </section>

      <div class='section container has-text-centered'>
          <h3 class='subtitle is-5'>Our platform provides a multitude of tools to help student entrepreneurs succeed</h3>
          <div class='columns'>
              <div class='column tool3'>
                  <!-- <b-icon icon="account-multiple"></b-icon> -->
                  <img src='static/images/male-leader.png'/>
                  <h3 class='title is-4'>Team building</h3>
                  <p>
                      Biaggeo helps projects find the right students with the right skills.
                      Our matching algorithms get a team going quicker.
                  </p>
              </div>
              <div class='column tool3'>
                  <!-- <b-icon icon="currency-usd"></b-icon> -->
                  <img src='static/images/crowdfunding.png'/>
                  <h3 class='title is-4'>Crowdfunding</h3>
                  <p>
                      Projects can choose to raise capital through non-equity based crowdfunding,
                      leveraging their friends, family, peers, and alumni.
                  </p>
              </div>
              <div class='column tool3'>
                  <!-- <b-icon icon="voice"></b-icon> -->
                  <img src='static/images/connect.png'/>
                  <h3 class='title is-4'>Networking</h3>
                  <p>
                      Alumni engage with student projects, provide feedback, and
                      strengthen the university's network.
                  </p>
              </div>
          </div>
      </div>

      <div class='section container'>
          <div class='has-text-centered'>
              <h2 class='title is-4'>How it works</h2>
              <br/>
          </div>
          <div class='columns'>
              <div class='column'>
                  <img src='https://placehold.it/600x400'/>
              </div>
              <div class='column'>
                  <h4 class='title is-4'>Lorem ipsum</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed porttitor ex ut dui condimentum, a ornare lectus blandit. Etiam vulputate, nunc eu rutrum mattis, mi est porta ipsum, eu placerat nulla sem commodo odio. Etiam pulvinar quam et ligula posuere varius quis et nulla. Ut ultrices varius iaculis. Suspendisse quis condimentum mauris. Fusce et orci sem. In hac habitasse platea dictumst. Sed tincidunt consequat vulputate. Aliquam accumsan, mauris et mollis lobortis, mauris ante lobortis orci, et lobortis metus nulla et felis. </p>
              </div>
          </div>
          <div class='columns'>
              <div class='column'>
                  <h4 class='title is-4'>Lorem ipsum</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed porttitor ex ut dui condimentum, a ornare lectus blandit. Etiam vulputate, nunc eu rutrum mattis, mi est porta ipsum, eu placerat nulla sem commodo odio. Etiam pulvinar quam et ligula posuere varius quis et nulla. Ut ultrices varius iaculis. Suspendisse quis condimentum mauris. Fusce et orci sem. In hac habitasse platea dictumst. Sed tincidunt consequat vulputate. Aliquam accumsan, mauris et mollis lobortis, mauris ante lobortis orci, et lobortis metus nulla et felis. </p>
              </div>
              <div class='column'>
                  <img src='https://placehold.it/600x400'/>
              </div>
          </div>
          <div class='columns'>
              <div class='column'>
                  <img src='https://placehold.it/600x400'/>
              </div>
              <div class='column'>
                  <h4 class='title is-4'>Lorem ipsum</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed porttitor ex ut dui condimentum, a ornare lectus blandit. Etiam vulputate, nunc eu rutrum mattis, mi est porta ipsum, eu placerat nulla sem commodo odio. Etiam pulvinar quam et ligula posuere varius quis et nulla. Ut ultrices varius iaculis. Suspendisse quis condimentum mauris. Fusce et orci sem. In hac habitasse platea dictumst. Sed tincidunt consequat vulputate. Aliquam accumsan, mauris et mollis lobortis, mauris ante lobortis orci, et lobortis metus nulla et felis. </p>
              </div>
          </div>
          <div class='columns'>
              <div class='column'>
                  <h4 class='title is-4'>Lorem ipsum</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed porttitor ex ut dui condimentum, a ornare lectus blandit. Etiam vulputate, nunc eu rutrum mattis, mi est porta ipsum, eu placerat nulla sem commodo odio. Etiam pulvinar quam et ligula posuere varius quis et nulla. Ut ultrices varius iaculis. Suspendisse quis condimentum mauris. Fusce et orci sem. In hac habitasse platea dictumst. Sed tincidunt consequat vulputate. Aliquam accumsan, mauris et mollis lobortis, mauris ante lobortis orci, et lobortis metus nulla et felis. </p>
              </div>
              <div class='column'>
                  <img src='https://placehold.it/600x400'/>
              </div>
          </div>
      </div>

      <div class='section container has-text-centered'>
          <h2 class='title is-4'>Ready to take entrepreneurship on your campus to the next level?</h2>
          <a class='button is-large is-success'>
              <b-icon size="is-medium" icon="calendar"></b-icon>
              <span>Schedule a demo</span>
          </a>
      </div>

  </div>
</template>

<script>
export default {
  name: 'Index',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style scoped>
.tool3 h3 {
    border-top: 1px dashed #777;
    border-bottom: 1px dashed #777;
    width: 70%;
    margin: auto;
    padding: 10px 0;
}
.tool3 p {
    margin-top: 10px;
    font-size: 1.1em;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Index.vue